function getTelephonesJSON(url) {
  return new Promise((resolve, reject) => {
    let http_request = new XMLHttpRequest();
    http_request.open('GET', url + '/resources/telephoneJSON.txt', true);
    http_request.onreadystatechange = () => {
      if (http_request.readyState == 4) {
        sessionStorage.setItem('telephonesJSON', http_request.responseText)
        return resolve(true)
      }
    };
    http_request.send(null)
  })
}
function getChannel() {
  const telephonesJSON = JSON.parse(sessionStorage.getItem('telephonesJSON'))
  let channel = {}
  if (window.innerWidth < 992) {
    channel = telephonesJSON.channels.find(channel => channel.name == 'MOBILE TELEPHONES')
  } else {
    channel = telephonesJSON.channels.find(channel => channel.defaultChannel == 'Yes')
  }
  return channel
}

function getChannelB2B(domain, b2bData) {
  const protocol = process.env.protocol
  const url = protocol + domain
  const telephonesJSON = JSON.parse(sessionStorage.getItem('telephonesJSON'))
  try {
    return getPhonesB2B(telephonesJSON, b2bData)
  } catch (e) {
    console.log(e)
  }
}

function getPhonesB2B(phones, b2bData) {
  var types = { "co": "companies", "ag": "agencies" }
  return phones.channels.find(channel => ((channel.name).toLowerCase()).includes(types[(b2bData.type).toLowerCase()])) || {}
}

function getGlobalPhone(channel) {
  return channel ? channel.globalChannel : ""
}

function getUserCountry() {
  var akamaiUserCountry = typeof sessionStorage.store != 'undefined' ? JSON.parse(sessionStorage.store).akamai.userData.userCountryCode : ''
  return akamaiUserCountry
}

function getPhoneObject(defaultText) {
  let countryName = ""
  let telephone = ""
  let countryCode = ""
  let globalTelephone = ""
  if (sessionStorage.getItem('telephonesJSON')) {
    const channel = getChannel()
    globalTelephone = getGlobalPhone(channel)
    const country = getUserCountry()
    const telephones = channel.telephones
    let countryFound = false
    telephones.forEach((telephoneElement) => {
      if (!countryFound) {
        if (telephoneElement.country == country) {
          telephone = telephoneElement.telephone
          countryName = telephoneElement.countryName
          countryCode = telephoneElement.country
          countryFound = true
        } else {
          telephone = globalTelephone
          countryCode = defaultText
          countryName = defaultText
        }
      }
    });
  }
  return { telephone, countryName, countryCode, globalTelephone }
}

function getPhoneObjectB2B(defaultText, domain, b2bData) {
  let countryName = ""
  let telephone = ""
  let countryCode = ""
  let globalTelephone = ""
  if (sessionStorage.getItem('telephonesJSON')) {
    const channel = getChannelB2B(domain, b2bData)
    globalTelephone = getGlobalPhone(channel)
    const country = getUserCountry()
    const telephones = channel ? channel.telephones : ''
    let countryFound = false
    if (telephones) {
      telephones.forEach((telephoneElement) => {
        if (!countryFound) {
          if (telephoneElement.country == country) {
            telephone = telephoneElement.telephone
            countryName = telephoneElement.countryName
            countryCode = telephoneElement.country
            countryFound = true
          } else {
            telephone = globalTelephone
            countryCode = defaultText
            countryName = defaultText
          }
        }
      })
    }
  }
  return { telephone, countryName, countryCode, globalTelephone }
}

function getHeaderPhonesList() {
  let html = ""
  if (sessionStorage.getItem('telephonesJSON')) {
    const channel = getChannel()
    const country = getUserCountry()
    const telephones = channel.telephones

    telephones.forEach(telephoneObject => {
      if (telephoneObject.country != country) {
        html += '<li><a href="tel:' + telephoneObject.telephone + '">' + telephoneObject.telephone + ' (' + telephoneObject.country + ')' + '</a></li>'
      }
    });
  }
  return html
}

function getHeaderPhonesListB2B(domain, b2bData) {
  let html = ""
  if (sessionStorage.getItem('telephonesJSON')) {
    const channel = getChannelB2B(domain, b2bData)
    const country = getUserCountry()
    const telephones = channel ? channel.telephones : ''

    if (telephones) {
      telephones.forEach(telephoneObject => {
        if (telephoneObject.country != country) {
          html += '<li><a href="tel:' + telephoneObject.telephone + '">' + telephoneObject.telephone + ' (' + telephoneObject.country + ')' + '</a></li>'
        }
      })
    }
  }
  return html
}

module.exports = {
  getTelephonesJSON,
  getPhoneObject,
  getHeaderPhonesList,
  getHeaderPhonesListB2B,
  getPhoneObjectB2B
} 